<template>
  <footer
    class="grid grid-flow-row lg:grid-flow-col gap-10 p-10 bg-neutral text-neutral-content justify-evenly"
  >
    <aside class="footer-section">
      <i class="fas fa-music text-5xl"></i>
      <p>Sqwerv Records LLC.</p>
      <p>© Sqwerv Records LLC {{ currentYear }}</p>
    </aside>
    <nav class="footer-section">
      <h6 class="footer-title">Social</h6>
      <div class="grid grid-flow-col gap-4">
        <social-navbar size="fa-2x" />
      </div>
    </nav>
    <nav class="footer-section grid-flow-col auto-cols-max gap-x-10">
      <div>
        <h6 class="footer-title">Booking</h6>
        <div
          v-for="contact in bookingContacts"
          :key="contact.email"
          class="mb-2"
        >
          <p class="font-semibold">{{ contact.name }}</p>
          <a :href="`mailto:${contact.email}`" class="link link-hover">{{
            contact.email
          }}</a>
        </div>
      </div>
      <div>
        <h6 class="footer-title">Management</h6>
        <div class="mb-2">
          <p class="font-semibold">{{ managementContact.name }}</p>
          <a
            :href="`mailto:${managementContact.email}`"
            class="link link-hover"
            >{{ managementContact.email }}</a
          >
        </div>
      </div>
    </nav>
    <form class="w-80 footer-section">
      <h6 class="footer-title">Newsletter</h6>
      <mail-chimp-input />
    </form>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import MailChimpInput from '@/components/MailChimpInput.vue'
import SocialNavbar from '@/components/SocialNavbar.vue'

const bookingContacts = [
  { name: 'David Limentani', email: 'David@minttalentgroup.com' },
]
const managementContact = { name: 'Oz McGuire', email: 'ozmcguire@gmail.com' }
const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer-section {
  display: grid;
  justify-items: start;
  text-align: left;
}
</style>
